<!--
  --
  -- 区切り線コンポーネント
  --
  -->
<template>
  <v-divider style="margin-top: 7px; margin-bottom: 8px"/>
</template>

<script>
export default {
  name: 'CDivider'
}
</script>
